export default __webpack_public_path__ + "static/media/andres.273044a3.jpg";